// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R4B1b1 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  min-width: 0;
  padding: var(--spacing-3) 0;
}

.YylthG {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  line-height: var(--type-title-lg-line-height);
  color: var(--text-neutral-dark);
}

.wlqZYz {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-3);
  width: 100%;
  min-height: 373px;
  padding: var(--spacing-3) var(--spacing-3);
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  text-align: center;
}

.f_Z6QO {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-primary-subtle);
}

.cOq4L7 {
  width: 16px;
  height: 16px;
}

.jpyLIV {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  width: 270px;
  max-width: 100%;
  color: var(--text-neutral-dark);
}

.u9SPaE {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.pZyS7o {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
}

.vhtX3v {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 373px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
}

.axXXc2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);
}

.ATJeJk {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
}

._3Qsf8 button {
  gap: var(--spacing-0-5);
}

._3Qsf8 button img {
  width: 12px;
  height: 12px;
  filter: brightness(0) invert(1);
}

.LLn45Z {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.tBXiQk {
  width: 100%;
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
}

.wi_fsr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 373px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.Nf7uMT {
  display: grid;
  grid-template-columns: 733fr 355fr;
  gap: var(--spacing-3);
  width: 100%;
  align-items: stretch;
}

.hNqHHG {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 343px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.BagXvj {
  display: flex;
  align-items: center;
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
}

.hv8Fyt {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.YEJdjJ {
  width: 100%;
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
}

.ym4a5g {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-3);
  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3) var(--spacing-3);
  text-align: center;
}

.MGtrTY {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-primary-subtle);
}

.DOaNB5 {
  width: 16px;
  height: 16px;
}

.dzBsJI {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  color: var(--text-neutral-dark);
}

.DZeA2P {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.bo5K6k {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
}

._lvWTq {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--spacing-1-5);
  align-content: flex-start;
}

.hYBwsX {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 111px;
  height: 111px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.SsbaOc {
  display: block;
  padding: 0;
  border: none;
  background: none;
  text-align: inherit;
  cursor: pointer;
}

.SsbaOc:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-s);
}

.njY0E3 {
  width: 16px;
  height: 16px;
}

.QxPC8v {
  display: block;
  width: 100%;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  overflow-wrap: break-word;
}

@media (max-width: 1023px) {
  .Nf7uMT {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .R4B1b1 {
    gap: var(--spacing-2);
    padding: var(--spacing-2) 0;
  }

  .axXXc2 {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1-5);
  }

  .Nf7uMT {
    gap: var(--spacing-2);
  }

  ._lvWTq {
    flex-direction: column;
    gap: var(--spacing-1-5);
  }

  .hYBwsX {
    flex: 1 1 auto;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HomePageEmissor/HomePageEmissor.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,8CAA8C;EAC9C,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,qBAAqB;EACrB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n  min-width: 0;\n  padding: var(--spacing-3) 0;\n}\n\n.pageTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  line-height: var(--type-title-lg-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-3);\n  width: 100%;\n  min-height: 373px;\n  padding: var(--spacing-3) var(--spacing-3);\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  text-align: center;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-primary-subtle);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.textBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  width: 270px;\n  max-width: 100%;\n  color: var(--text-neutral-dark);\n}\n\n.title {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.body {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n}\n\n.ordersCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 373px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n}\n\n.ordersHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);\n}\n\n.ordersHeaderLeft {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-3);\n}\n\n.newRechargeButton button {\n  gap: var(--spacing-0-5);\n}\n\n.newRechargeButton button img {\n  width: 12px;\n  height: 12px;\n  filter: brightness(0) invert(1);\n}\n\n.ordersTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.ordersDivider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 373px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.placeholderGrid {\n  display: grid;\n  grid-template-columns: 733fr 355fr;\n  gap: var(--spacing-3);\n  width: 100%;\n  align-items: stretch;\n}\n\n.rastreioCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 343px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.rastreioHeader {\n  display: flex;\n  align-items: center;\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);\n}\n\n.rastreioTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.rastreioDivider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.rastreioBody {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--spacing-3);\n  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3) var(--spacing-3);\n  text-align: center;\n}\n\n.bigIconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-primary-subtle);\n}\n\n.bigIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.rastreioEmptyText {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  color: var(--text-neutral-dark);\n}\n\n.rastreioEmptyTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.rastreioEmptyBody {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n}\n\n.quickActionsRow {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: var(--spacing-1-5);\n  align-content: flex-start;\n}\n\n.quickActionCard {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 111px;\n  height: 111px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.quickActionButton {\n  display: block;\n  padding: 0;\n  border: none;\n  background: none;\n  text-align: inherit;\n  cursor: pointer;\n}\n\n.quickActionButton:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-s);\n}\n\n.quickActionIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.quickActionLabel {\n  display: block;\n  width: 100%;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  overflow-wrap: break-word;\n}\n\n@media (max-width: 1023px) {\n  .placeholderGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    gap: var(--spacing-2);\n    padding: var(--spacing-2) 0;\n  }\n\n  .ordersHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1-5);\n  }\n\n  .placeholderGrid {\n    gap: var(--spacing-2);\n  }\n\n  .quickActionsRow {\n    flex-direction: column;\n    gap: var(--spacing-1-5);\n  }\n\n  .quickActionCard {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `R4B1b1`,
	"pageTitle": `YylthG`,
	"card": `wlqZYz`,
	"iconContainer": `f_Z6QO`,
	"icon": `cOq4L7`,
	"textBlock": `jpyLIV`,
	"title": `u9SPaE`,
	"body": `pZyS7o`,
	"ordersCard": `vhtX3v`,
	"ordersHeader": `axXXc2`,
	"ordersHeaderLeft": `ATJeJk`,
	"newRechargeButton": `_3Qsf8`,
	"ordersTitle": `LLn45Z`,
	"ordersDivider": `tBXiQk`,
	"loadingContainer": `wi_fsr`,
	"placeholderGrid": `Nf7uMT`,
	"rastreioCard": `hNqHHG`,
	"rastreioHeader": `BagXvj`,
	"rastreioTitle": `hv8Fyt`,
	"rastreioDivider": `YEJdjJ`,
	"rastreioBody": `ym4a5g`,
	"bigIconWrapper": `MGtrTY`,
	"bigIcon": `DOaNB5`,
	"rastreioEmptyText": `dzBsJI`,
	"rastreioEmptyTitle": `DZeA2P`,
	"rastreioEmptyBody": `bo5K6k`,
	"quickActionsRow": `_lvWTq`,
	"quickActionCard": `hYBwsX`,
	"quickActionButton": `SsbaOc`,
	"quickActionIcon": `njY0E3`,
	"quickActionLabel": `QxPC8v`
};
module.exports = ___CSS_LOADER_EXPORT___;
